import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const VerifiyLrg = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill="#d4f0e5"
      fillRule="evenodd"
      d="M12,22s6.5857864-1.7573593,8-6c1-3,1-10,1-10l-9-3L3,6s0,7,1,10c1.4142136,4.2426407,8,6,8,6Z"
    />
    <path
      fill="#207e56"
      d="M12,4.0540895l7.9920731,2.6640248c-.0312142,1.8331628-.1849799,6.6983443-.940753,8.9656556-1.0788727,3.2366092-5.8786267,4.9090025-7.0513201,5.2734931-1.1726934-.3644905-5.9724474-2.0368838-7.0513201-5.2734931-.7557731-2.2673113-.9095387-7.1324928-.940753-8.9656556l7.9920731-2.6640248M12,3L3,6s0,7,1,10c1.4142098,4.24264,8,6,8,6,0,0,6.5857902-1.75736,8-6,1-3,1-10,1-10l-9-3h0Z"
    />
    <path
      fill="#207e56"
      d="M11,16.4550781c-.2822266,0-.5527344-.1191406-.7431641-.3310547l-2.25-2.5c-.3696289-.4101562-.3364258-1.0429688.0742188-1.4121094.4106445-.3696289,1.043457-.3359375,1.4121094.0742188l1.3808594,1.5341797,3.5390625-5.4125977c.3027344-.4619141.9213867-.5908203,1.3842773-.2895508.4619141.3022461.5917969.921875.2895508,1.3842773l-4.25,6.4995117c-.1699219.2597656-.4506836.4267578-.7602539.4501953-.0253906.0019531-.0512695.0029297-.0766602.0029297Z"
    />
  </SvgIcon>
);

export default VerifiyLrg;
